import React from "react";
import logo from "../assets/Logomain.jpg";
import ndisBadge from "../assets/Logomain.jpg";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <img src={logo} alt="Carenest Services AU" className="footer-logo" />
        </div>

        <div className="footer-col">
          <div className="footer-heading">Contact</div>
          <div className="footer-contact">
            <div>
              📞 <span>+61 426 533 333</span>
            </div>
            <div>
              ✉️ <span>info@carenestservicesau.com.au</span>
            </div>
          </div>
        </div>

        <div className="footer-col">
          <div className="footer-heading">Indigenous Acknowledgement</div>
          <p className="footer-text">
            Carenest Services AU acknowledges the Traditional Owners and
            Custodians of the Country throughout Australia and acknowledges
            their continuing connection to land, sea and community. We pay our
            respects to the people, the cultures and the Elders past, present
            and emerging.
          </p>
        </div>

        <div className="footer-col">
          <img src={ndisBadge} alt="NDIS Badge" className="footer-badge" />
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2021 – 2024 Carenest Services AU | All Rights Reserved</p>
        <p>ABN: 14 671 529 114 | ACN: 671 529 114</p>
      </div>
    </footer>
  );
}

export default Footer;
